import React, { Component } from "react";
import { Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import Select from "react-select";
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import NumberFormat from 'react-number-format';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import {ordersListNvRequest} from '../Orders/actions'
import * as chuongTrinhAction from './actions'
import * as cTrinhConstants from './constants'
import { storedb } from '../client/storedb'
import { BtnPermissions } from '../../lib/BtnPermissions';
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import { ButtonExt } from "../controls/ButtonExt"
import { customSelectStylesMulti } from '../../lib/common'

class ChuongTrinhEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {},
      nhomKh: [],
      formError: {},
      formValid: false,
      StoreId: dbContext.getStoreId(),
      selectedNhomKhOption: [],
      lstNvSelected: [],
      listNvkd: [],
      showDoanhSoApDung: false,
      showSoLuongApDung: false,
      showPhanTramChietKhau: false,
      showLoaiKh: false,
      showNhanVien: false,
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = ({target}, name) => {
    let { item } = this.state;
    var loai = 0;
    switch (name) {
      case "TrangThai":
        item.IsActive = target.value
        break;
      case "Loai":
        loai = target.value;
        item.DoanhSoApDung = 0;
        item.PercentCk = 0;
        item.SoLuongApDung = 0;
        item.Loai = loai;
        break;
      default:
        break;
    }
    this.setState({ item }, () => {
      if (loai > 0) {
        this.SetKieuChuongTrinh(loai);
      }
    })
  }
  SetKieuChuongTrinh = (loai) => {
    let {
      showDoanhSoApDung,
      showPhanTramChietKhau,
      showSoLuongApDung,
      showLoaiKh,
      showNhanVien,
    } = this.state

    switch (loai * 1) {
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_CODINH_THEO_NHOM:
        showDoanhSoApDung = false;
        showPhanTramChietKhau = true;
        showSoLuongApDung = false;
        showLoaiKh = true
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_THEM_THEO_SP:
        showDoanhSoApDung = false;
        showPhanTramChietKhau = true;
        showSoLuongApDung = true;
        showLoaiKh = false
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_TANG_HANG:
        showDoanhSoApDung = false
        showPhanTramChietKhau = false
        showSoLuongApDung = true
        showLoaiKh = true
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_THEO_DON:
        showDoanhSoApDung = true;
        showPhanTramChietKhau = true;
        showSoLuongApDung = false;
        showLoaiKh = false
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_THEM_THEO_NHOM:
        showDoanhSoApDung = true;
        showPhanTramChietKhau = true;
        showSoLuongApDung = false;
        showLoaiKh = false
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.KHONG_CK:
        showDoanhSoApDung = false;
        showPhanTramChietKhau = false;
        showSoLuongApDung = false;
        showLoaiKh = true
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.THUONG_DOANH_SO:
        showDoanhSoApDung = true;
        showPhanTramChietKhau = true;
        showSoLuongApDung = false;
        showLoaiKh = true
        showNhanVien = true
        break;
      default:
        showDoanhSoApDung = false;
        showPhanTramChietKhau = false;
        showSoLuongApDung = false;
        showLoaiKh = false
        showNhanVien = false
        break;
    }
    this.setState({ showDoanhSoApDung, showPhanTramChietKhau, showSoLuongApDung, showLoaiKh, showNhanVien })
  }
  handleMoneyChange = (name, data) => {
    let { item } = this.state;
    const value = data.floatValue;
    item[name] = value;
    this.setState({ item })
  }
  handleDateChange = (name, obj) => {
    let { item } = this.state;
    switch (name) {
      case "NgayApDung":
        item.NgayApDung = obj.format();
        break;
      case "NgayKetThuc":
        item.NgayKetThuc = obj.format();
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { chuongTrinhDetailRequest } = this.props
    let ChuongTrinhId = this.getParam("cid");
    var requestData = {
      ChuongTrinhId: ChuongTrinhId || 0,
      StoreId: this.state.StoreId
    }
    const onSuccess = ({campaign, nhomKhIds, nhanViens}) => {
      let selectedNhomKhOption = [], lstNvSelected = []
      if (campaign && campaign.ChuongTrinhId && campaign.ChuongTrinhId > 0) {
        if (nhomKhIds && nhomKhIds.length > 0) {
          campaign.NhomKhIds = []
          for (var i = 0; i < nhomKhIds.length; i++) {
            campaign.NhomKhIds.push(nhomKhIds[i].NhomId)
            selectedNhomKhOption.push({value: nhomKhIds[i].NhomId, label: nhomKhIds[i].Ten})
          }
        }
        if (nhanViens && nhanViens.length > 0) {
          campaign.UserIds = []
          for (var i = 0; i < nhanViens.length; i++) {
            campaign.UserIds.push(nhanViens[i].NguoiDungId)
            lstNvSelected.push({value: nhanViens[i].NguoiDungId, label: nhanViens[i].Ten})
          }
        }
        this.setState({ item: campaign, selectedNhomKhOption, lstNvSelected }, () => {
          this.SetKieuChuongTrinh(campaign.Loai);
        });
      } else {
        this.setState({ item: {}, selectedNhomKhOption, lstNvSelected })
      }
    }
    return chuongTrinhDetailRequest(requestData, onSuccess);
  }
  UpdateChuongTrinh = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Loai || this.state.item.Loai == 0) {
      formError.Loai = 'Bạn chưa nhập kiểu chương trình';
    }
    if (!this.state.item.TenChuongTrinh || this.state.item.TenChuongTrinh == "") {
      formError.TenChuongTrinh = 'Bạn chưa nhập tên chương trình';
    }
    if (this.state.item.IsActive == undefined || this.state.item.IsActive == -1) {
      formError.IsActive = 'Bạn chưa nhập trạng thái';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state;
      item.StoreId = this.state.StoreId;

      const callback = () => {
        setTimeout(() => {
          this.props.history.push("/chuong-trinh")
        }, 2000)
      }
      this.props.chuongTrinhUpdateRequest(item, callback);
    }
  }
  BackToListChuongTrinh = (item, e) => {
    this.props.history.push('/chuong-trinh');
  }
  getListNhomKh = () => {
    var requestData = {
      storeId: this.state.StoreId
    }
    const onSuccess = ({data}) => {
      if (data) {
        this.setState({ nhomKh: data })
      } else {
        this.setState({ nhomKh: [] })
      }
    }
    return this.props.chuongTrinhListNhomKhRequest(requestData, onSuccess);
  }  
  getListNVKD() {
    const { ordersListNvRequest } = this.props
    const requestData =
    {
      store_id: this.state.store_id
    }
    const callBack = (data) => {
      this.setState({
        listNvkd: data
      });
    }
    return ordersListNvRequest(requestData, callBack)
  }
  onHandleRemove = (itemRemoved) => {
    let {lstNvSelected, item} = this.state
    var index = lstNvSelected.findIndex(e => e.value == itemRemoved.value);
    if (index > -1) {
      lstNvSelected.splice(index, 1);
    }
    item.UserIds = lstNvSelected.map(item => { return item.value })
    this.setState({ lstNvSelected, item })
  }
  onHandleChoice = (lstNvSelected) => {
    let {item} = this.state
    item.UserIds = lstNvSelected.map(item => { return item.value })
    this.setState({ lstNvSelected, item })
  }
  convertToMoment = (date) => {
    if (typeof date == 'string') {
      return moment(date);
    }
    return date;
  }
  handleChangeNhomKh = selectedNhomKhOption => {
    let { item } = this.state
    item.NhomKhIds = selectedNhomKhOption.map(it => { return it.value })
    this.setState({ selectedNhomKhOption, item });
  }
  componentDidMount() {
    this.getListNhomKh()
    this.getListNVKD()
    this.featchDetail()
  }
  render() {
    const { 
      formError, 
      item,
      nhomKh,
      selectedNhomKhOption
    } = this.state;
    const {
      chuongTrinhEdit: {
        isRequesting,
        errors,
        messages
      },
    } = this.props

    const genKieuCtrinh = () => {
      return cTrinhConstants.CHUONGTRINH_LIST_KIEU.map((item, index) => {
        return (
          <option key={index} value={item.id}>{item.name}</option>
        )
      })
    }
    const getOptionsLoaiKh = () => {
      if (nhomKh == null) return []
      return nhomKh.map(item => {
        return { value: item.Id, label: item.Ten }
      })
    }

    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <Form className="row">
            <FormGroup className="col-sm-6">
              <Label>Kiểu chương trình</Label>
              <select 
                name="Loai" 
                className="form-control" 
                value={item.Loai || 0} 
                onChange={e => this.handleSelectChange(e, "Loai")}
                >
                <option value={0}>--Kiểu Chương trình--</option>
                {genKieuCtrinh()}
              </select>
              <em className="error invalid-feedback">{formError.Loai}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Tên chương trình</Label>
              <Input type="text" name="TenChuongTrinh" placeholder="Tên chương trình" value={item.TenChuongTrinh || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.TenChuongTrinh}</em>
            </FormGroup>
            <FormGroup className="col-sm-3">
              <div><Label >Ngày bắt đầu</Label></div>
              <DatePicker name="NgayApDung" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.NgayApDung)} onChange={this.handleDateChange.bind(this, "NgayApDung")} className={"form-control"} />
              <em className="error invalid-feedback">{formError.NgayApDung}</em>
            </FormGroup>
            <FormGroup className="col-sm-3">
              <div><Label >Ngày kết thúc</Label></div>
              <DatePicker name="NgayKetThuc" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.NgayKetThuc)} onChange={this.handleDateChange.bind(this, "NgayKetThuc")} className={"form-control"} />
              <em className="error invalid-feedback">{formError.NgayKetThuc}</em>
            </FormGroup>
            <FormGroup className={this.state.showDoanhSoApDung ? "col-sm-6" : "d-none"}>
              <Label>Doanh số áp dụng</Label>
              <NumberFormat
                name={"DoanhSoApDung"}
                value={item.DoanhSoApDung}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "DoanhSoApDung")}
                className={"form-control order-input-price price"} />
            </FormGroup>
            <FormGroup className={this.state.showSoLuongApDung ? "col-sm-6" : "d-none"}>
              <Label >Số lượng áp dụng</Label>
              <NumberFormat
                name={"SoLuongApDung"}
                value={item.SoLuongApDung}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "SoLuongApDung")}
                className={"form-control order-input-price price"} />
            </FormGroup>
            <FormGroup className={this.state.showPhanTramChietKhau ? "col-sm-6" : "d-none"}>
              <Label>Phần trăm chiết khấu</Label>
              <NumberFormat
                name={"PercentCk"}
                value={(item.PercentCk || 0) * 1}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "PercentCk")}
                className={"form-control order-input-price price"} />
            </FormGroup>
            <FormGroup className={this.state.showLoaiKh ? "col-sm-6" : "d-none"}>
              <Label>Nhóm khách hàng</Label>
              <Select
                styles={customSelectStylesMulti}
                value={selectedNhomKhOption}
                onChange={this.handleChangeNhomKh}
                options={(getOptionsLoaiKh())}
                placeholder="--Nhóm khách hàng--"
                name="NhomKhachHang" 
                className="form-control p-0"
                isMulti
                closeMenuOnSelect={false}
              />
            </FormGroup>
            <FormGroup className={this.state.showNhanVien ? "col-sm-6" : "d-none"}>
              <Label>Chọn nhân viên</Label>
              <CheckboxTreeList
                placeholder={`--Nhân viên KD--`}
                nodes={this.state.listNvkd}
                checked={this.state.lstNvSelected}
                isMultiChoice={true}
                onHandleRemove={(item) => this.onHandleRemove(item)}
                onChoice={e => this.onHandleChoice(e)}
              />
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label>Trạng thái</Label>
              <select name="IsActive" className="form-control" value={item.IsActive} onChange={e => this.handleSelectChange(e, "TrangThai")}>
                <option value={-1}>--Trạng thái--</option>
                <option value={0}>Chưa chạy chương trình</option>
                <option value={1}>Đang chạy chương trình</option>
              </select>
              <em className="error invalid-feedback">{formError.IsActive}</em>
            </FormGroup>
            <FormGroup className="col-sm-12">
              <Label>Ghi chú</Label>
              <Input type="textarea" name="GhiChu" className="form-control" value={item.GhiChu || ''} onChange={this.handleControlChange.bind(this)} />
            </FormGroup>
          </Form>
          <Row>
            <Col md="12">
              {!isRequesting && !!errors.length && (
                <Errors errors={errors} />
              )}
              {!isRequesting && !!messages.length && (
                <Messages messages={messages} />
              )}
            </Col>
          </Row>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Về Danh sách"
              btnClick={() => this.BackToListChuongTrinh()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdateChuongTrinh()}
              permission={BtnPermissions.ChuongTrinh.ADD_OR_UPDATE} />
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  chuongTrinhEdit: state.chuongTrinhEdit,
})
const connected = connect(mapStateToProps, {
  chuongTrinhDetailRequest: chuongTrinhAction.chuongTrinhDetailRequest,
  chuongTrinhUpdateRequest: chuongTrinhAction.chuongTrinhUpdateRequest,
  chuongTrinhListRequest: chuongTrinhAction.chuongTrinhListRequest,
  chuongTrinhListNhomKhRequest: chuongTrinhAction.chuongTrinhListNhomKhRequest,
  ordersListNvRequest: ordersListNvRequest,
})(ChuongTrinhEdit)

const formed = reduxForm({
  form: 'chuongTrinhEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/ChuongTrinh/ChuongTrinhEdit.js